module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "white-background-hack"
  }, [_c('HomeDirect')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3a182f80!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PfriemstersCellarClub.vue
// module id = 371
// module chunks = 1